const TYPES = Object.freeze({
    "RESERVE_REDUCTION": "RSU",
    "DAMAGE": "DAM",
    "PENALIZATION": "PEP",
});

export default { TYPE: TYPES }